
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function HairGrowthPage() {
  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/consultation');
  };

  const treatments = [
    {
      name: 'Proprietary Hair Regrowth Blend',
      description: 'A unique combination of medications, shampoos, conditioners, supplements, and topical creams, all specifically formulated to promote hair growth and restore your hair\'s growth cycle.',
      benefits: ['Complete hair care system', 'Growth cycle restoration', 'Internal & external treatment', 'Extended growth phase']
    },
    {
      name: 'Daily Goodness Protein Shake',
      description: 'Packed with essential nutrients, this shake supports hair health from the inside out, providing your body with the building blocks it needs for strong, healthy hair.',
      benefits: ['Essential nutrients', 'Internal hair support', 'Building blocks for growth', 'Daily convenience']
    },
    {
      name: 'Infusions & Injections for Cellular Repair',
      description: 'Experience the power of mitochondrial repair with solutions like NAD+, Thymosin, Thyamlin, Epitalon, Mots-C, GHK-Cu, and BPC-157, designed to rejuvenate your body at a cellular level.',
      benefits: ['Mitochondrial repair', 'Cellular rejuvenation', 'Advanced peptides', 'Systemic healing']
    },
    {
      name: 'Prescription Treatments',
      description: 'Like Metformin, Minoxidil and Finasteride prescriptions for both men and women (with specific guidelines for women of childbearing age), helping to regulate hair loss and promote regrowth.',
      benefits: ['FDA-approved medications', 'Gender-specific protocols', 'Hair loss regulation', 'Proven effectiveness']
    },
    {
      name: 'Topical Minoxidil & Finasteride',
      description: 'These powerful topical treatments work directly on your scalp, stimulating hair follicles to encourage regrowth and thickness.',
      benefits: ['Direct scalp application', 'Follicle stimulation', 'Increased thickness', 'Targeted treatment']
    },
    {
      name: 'Micro Needling',
      description: 'A highly effective treatment that stimulates the scalp and promotes collagen production to boost hair growth.',
      benefits: ['Scalp stimulation', 'Collagen production', 'Enhanced absorption', 'Natural growth boost']
    },
    {
      name: 'PRP/PRF with DMSO',
      description: 'Platelet-Rich Plasma and Platelet-Rich Fibrin therapy, enhanced with DMSO, promotes healing and rejuvenation, ensuring optimal hair regrowth.',
      benefits: ['Platelet-rich therapy', 'Enhanced healing', 'Natural rejuvenation', 'Optimal regrowth']
    },
    {
      name: 'Red Light Therapy',
      description: 'Using specific wavelengths of light, this treatment helps to invigorate hair follicles and stimulate growth by improving blood circulation and cellular activity.',
      benefits: ['Light wavelength therapy', 'Follicle invigoration', 'Improved circulation', 'Cellular activation']
    }
  ];

  const services = [
    {
      icon: 'ri-user-heart-line',
      title: 'Provider Assessment',
      description: 'Comprehensive evaluation by our hair restoration specialists'
    },
    {
      icon: 'ri-capsule-line',
      title: 'Prescription Medications',
      description: 'Both oral and topical medications tailored to your needs'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Custom Treatment Plan',
      description: 'Personalized protocol designed for your specific hair loss pattern'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Same Day Appointments',
      description: 'Quick access to consultations and treatment initiation'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Cutting Edge Treatments',
      description: 'Access to the latest innovations in hair restoration'
    },
    {
      icon: 'ri-dna-line',
      title: 'Stem Cell Services',
      description: 'Advanced regenerative medicine for hair follicle restoration'
    },
    {
      icon: 'ri-plane-line',
      title: 'Turkish Hair Transplant',
      description: 'Heavy discounts on award-winning Turkish hair transplant services'
    },
    {
      icon: 'ri-drop-line',
      title: 'Infusion Services',
      description: 'IV therapy and injections for comprehensive hair health support'
    }
  ];

  const benefits = [
    {
      icon: 'ri-leaf-line',
      title: 'Natural Approach',
      description: 'Holistic treatments that work with your body\'s natural processes'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Proven Results',
      description: 'Evidence-based treatments with documented success rates'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Personalized Care',
      description: 'Every treatment plan is customized to your unique needs'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Partnerships',
      description: 'Access to world-class hair transplant clinics with award-winning results'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-[#8A4F8A] to-[#C8A2C8] text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/a10f8604063c6fe0566ec3f4e3cab275/55849437ca1cac9a0253e9cbf600d851.png)'
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Advanced <span className="text-[#F0F0F0]">Hair Growth Treatment</span>
            </h1>
            <p className="text-xl mb-8 text-[#F0F0F0]">
              Comprehensive hair restoration using cutting-edge peptides, PRP therapy, and innovative treatments for thicker, stronger, healthier hair growth.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="bg-white text-[#8A4F8A] hover:bg-[#F0F0F0]" onClick={handleConsultationClick}>
                <i className="ri-calendar-line mr-2"></i>
                Schedule Assessment
              </Button>
              <Button size="lg" variant="secondary" className="border-white text-white hover:bg-white hover:text-[#8A4F8A]" onClick={() => window.open('tel:202-269-6600', '_self')}>
                <i className="ri-phone-line mr-2"></i>
                Call 202-269-6600
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Why Choose Our <span className="text-[#8A4F8A]">Hair Growth Solutions</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Comprehensive approach to hair restoration with cutting-edge treatments
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-black mb-3">{benefit.title}</h3>
                <p className="text-[#B0B0B0]">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Overview Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Our <span className="text-[#8A4F8A]">Services Include</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Comprehensive hair restoration services from assessment to advanced treatments
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${service.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-black mb-3">{service.title}</h3>
                <p className="text-[#B0B0B0] text-sm">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Treatment Options Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Advanced <span className="text-[#8A4F8A]">Treatment Options</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Cutting-edge therapies designed to restore and enhance hair growth
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {treatments.map((treatment, index) => (
              <div key={index} className="bg-gradient-to-b from-[#F0F0F0] to-white rounded-xl shadow-lg p-6">
                <h3 className="text-xl font-bold text-black mb-3">{treatment.name}</h3>
                <p className="text-[#B0B0B0] mb-4 text-sm">{treatment.description}</p>
                
                <ul className="space-y-2">
                  {treatment.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-center text-black text-sm">
                      <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comprehensive Assessment Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-black mb-4">
            Comprehensive <span className="text-[#8A4F8A]">Hair Health Assessment</span>
          </h2>
          <p className="text-xl text-[#B0B0B0] mb-8">
            Each treatment is customized to your individual needs, considering all factors that may contribute to hair loss
          </p>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="text-left">
                <h3 className="text-lg font-bold text-black mb-3">Assessment Factors:</h3>
                <ul className="space-y-2">
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Hormonal analysis and balance
                  </li>
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Circulation and blood flow assessment
                  </li>
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Diabetes and metabolic factors
                  </li>
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Nutritional deficiencies evaluation
                  </li>
                </ul>
              </div>
              <div className="text-left">
                <h3 className="text-lg font-bold text-black mb-3">Treatment Benefits:</h3>
                <ul className="space-y-2">
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Personalized treatment protocols
                  </li>
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Address root causes, not just symptoms
                  </li>
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Comprehensive health optimization
                  </li>
                  <li className="flex items-center text-black text-sm">
                    <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                    Long-term hair health maintenance
                  </li>
                </ul>
              </div>
            </div>

            <Button size="lg" className="w-full" onClick={handleConsultationClick}>
              <i className="ri-user-search-line mr-2"></i>
              Schedule Your Hair Health Assessment
            </Button>
          </div>
        </div>
      </section>

      {/* Turkish Hair Transplant Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              World-Class <span className="text-[#8A4F8A]">Hair Transplant Services</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Connection to the best Turkish hair transplant clinics with award-winning results
            </p>
          </div>

          <div className="bg-gradient-to-b from-[#F0F0F0] to-white rounded-xl shadow-lg p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-black mb-4">Premium Hair Transplant Access</h3>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-center text-black">
                    <i className="ri-award-line text-[#8A4F8A] mr-3"></i>
                    Award-winning Turkish clinics
                  </li>
                  <li className="flex items-center text-black">
                    <i className="ri-discount-percent-line text-[#8A4F8A] mr-3"></i>
                    Massive discounts for our patients
                  </li>
                  <li className="flex items-center text-black">
                    <i className="ri-user-star-line text-[#8A4F8A] mr-3"></i>
                    World-renowned surgeons
                  </li>
                  <li className="flex items-center text-black">
                    <i className="ri-shield-check-line text-[#8A4F8A] mr-3"></i>
                    Guaranteed results and aftercare
                  </li>
                </ul>
                <Button size="lg" onClick={handleConsultationClick}>
                  <i className="ri-plane-line mr-2"></i>
                  Learn About Hair Transplant Options
                </Button>
              </div>
              <div className="text-center">
                <img 
                  src="https://public.readdy.ai/ai/img_res/07167b97904aae75d5f145b48f492691.jpg"
                  alt="Hair Transplant Services"
                  className="w-full h-64 object-cover object-top rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Your <span className="text-[#8A4F8A]">Hair Restoration Journey</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: '1', title: 'Comprehensive Assessment', description: 'Detailed evaluation of hair loss patterns and contributing factors' },
              { step: '2', title: 'Custom Treatment Plan', description: 'Personalized protocol combining multiple treatment modalities' },
              { step: '3', title: 'Treatment Implementation', description: 'Begin your customized hair restoration program' },
              { step: '4', title: 'Ongoing Monitoring', description: 'Regular progress tracking and treatment optimization' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold">{item.step}</span>
                </div>
                <h3 className="text-lg font-bold text-black mb-2">{item.title}</h3>
                <p className="text-[#B0B0B0] text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#8A4F8A] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Restore Your Hair?</h2>
          <p className="text-xl mb-8 text-[#F0F0F0]">
            Start your journey to thicker, stronger, healthier hair today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-white text-[#8A4F8A] hover:bg-[#F0F0F0]" onClick={handleConsultationClick}>
              <i className="ri-calendar-line mr-2"></i>
              Schedule Assessment
            </Button>
            <Button size="lg" variant="secondary" className="border-white text-white hover:bg-white hover:text-[#8A4F8A]" onClick={() => window.open('tel:202-269-6600', '_self')}>
              <i className="ri-phone-line mr-2"></i>
              Call 202-269-6600
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
